<template>
    <div>
        <card-header icon="fa-message-check">
            <template #title>
                User Requests/Actions
            </template>
        </card-header>

        <card-body>
            <card-list>
                <plan-request-tile :request="request" :card="card" v-for="request in plan.requests"/>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import {client as http} from '@/http_client';
    import async from "async";
    import DataRow from "../../TIER/components/DataRow";
    import PlanNoteTile from "../../components/tiles/PlanNoteTile.vue";
    import PlanRequestTile from "../../components/tiles/PlanRequestTile.vue";

    export default {
        components: {PlanRequestTile, PlanNoteTile, DataRow, SeparatorListItem, CardFooter, CardToolbar, CardContainer, NavigationListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                plan: null,
            };
        },
        methods: {
            loadPlan: function() {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('payment-plans/' + this.props.planId, {force: true}).then(response => {
                            this.plan = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            },
            reload: function () {
                this.loadPlan();
            }
        },
        mounted() {
            this.loadPlan();
        }
    };
</script>

<style>
    .fa-check {
        color: green;
    }

    .fa-ban {
        color: red;
    }
</style>
